<template>
  <div
    v-if="show"
    class="text-[var(--text)] gap-1 p-1 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half"
    id="form_btn_container"
  >
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <h3 class="text-[18px] font-bold" style="color: var(--titulo)">
        {{ form_title }}
      </h3>
 
      <div>
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>

    <div class="form_container">
      <div id="left_form" class="left_form gap-y-2">
        <div class="input_container">
          <label for="utilizador" class="input_label">Utilizador:</label>
          <input
            :disabled="form_data.status == 'desativado' || !create_user"
            type="text"
            v-model="formData.utilizador"
            placeholder="Utilizador"
            class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{
              'bg-gray-500 text-[var(--text)]': !create_user,
              'input-required': create_user && isEmptyField('utilizador'),
            }"
          />
        </div>

        <div v-if="create_user" class="input_container">
          <label for="password" class="input_label">Password:</label>
          <input
            style="color: var(--text)"
            :disabled="form_data.status == 'desativado'"
            type="password"
            v-model="formData.password"
            placeholder="Password"
            class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{ 'input-required': isEmptyField('password') }"
          />
        </div>

        <div v-if="!isClientType" class="input_container">
          <label for="nif" class="input_label">NIF:</label>
          <input
            :disabled="form_data.status == 'desativado' || !create_user"
            type="text"
            v-model="formData.nif"
            placeholder="NIF"
            class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{
              'bg-gray-500 text-[var(--text)]': !create_user,
              'input-required': create_user && isEmptyField('nif'),
            }"
          />
        </div>
        <div v-if="!isClientType" class="input_container">
          <label for="nif" class="input_label">CC:</label>
          <input
            :disabled="form_data.status == 'desativado' || !create_user"
            type="text"
            v-model="formData.cc"
            placeholder="CC"
            class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{
              'bg-gray-500 text-[var(--text)]': !create_user,
              'input-required': create_user && isEmptyField('cc'),
            }"
          />
        </div>

        <div class="data_set_class">
          <div class="data_set gap-y-1">
            <div style="min-width: 142px">Tipo Utilizador:</div>

            <div
              :style="{
                color:
                  set_data.tipo_utilizador.id === 0
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              {{ set_data.tipo_utilizador.nome }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0014')
                "
                @click="openDialog('tputilizador')"
              >
                <Icon :style="iconStyleObr()" icon="lucide:hard-hat" />
              </button>
            </div>
          </div>
          <div
            v-if="set_data.tipo_utilizador.nome == 'cliente'"
            class="data_set"
          >
            <div style="min-width: 142px">Cliente:</div>

            <div
              v-bind:style="{
                color:
                  set_data.cliente.id === 0
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              {{ set_data.cliente.cliente }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0028')
                "
                :style="{
                  color:
                    set_data.tipo_utilizador.id === 0
                      ? 'var(--obrigatorio)'
                      : 'var(--icon)',
                }"
                @click="openDialog('cliente')"
              >
                <Icon icon="lucide:shopping-cart" />
              </button>
            </div>
          </div>

          <!-- Sub-Clientes: todos os acessos do utilizador, agrupados por cliente -->
          <div v-if="showSubclientesPanel" class="data_set_subclientes">
            <div class="subclientes_header">
              <div style="min-width: 142px; color: var(--label); font-size: 14px;">Sub-Clientes:</div>
              <div
                v-if="!loadingSubclientes && hasMultiplosClientes"
                class="subclientes_resumo"
              >
                {{ selectedSubclienteIds.length }} selecionado(s)
                <span v-if="outrosClientesCount > 0" class="subclientes_aviso">
                  · {{ outrosClientesCount }} noutro(s) cliente(s)
                </span>
              </div>
            </div>

            <div v-if="loadingSubclientes" class="text-xs" style="color: var(--icon);">A carregar...</div>
            <div v-else-if="subclienteGroups.length === 0" class="text-xs" style="color: var(--icon);">Sem sub-clientes</div>
            <div v-else class="subclientes-list">
              <div
                v-for="grupo in subclienteGroups"
                :key="grupo.clienteId"
                :class="[
                  hasMultiplosClientes
                    ? 'subcliente_grupo'
                    : 'subcliente_grupo_simples',
                  { subcliente_grupo_outro: hasMultiplosClientes && !grupo.isCurrent },
                ]"
              >
                <div v-if="hasMultiplosClientes" class="subcliente_grupo_header">
                  <span class="subcliente_grupo_nome">
                    {{ grupo.clienteNome }}
                    <span v-if="!grupo.isCurrent" class="subclientes_aviso">(outro cliente)</span>
                  </span>
                  <span
                    v-if="form_data.status != 'desativado'"
                    class="subcliente_grupo_acoes"
                  >
                    <button type="button" @click="setGrupoSelecao(grupo, true)">Todos</button>
                    <button type="button" @click="setGrupoSelecao(grupo, false)">Nenhum</button>
                  </span>
                </div>
                <label
                  v-for="sub in grupo.subclientes"
                  :key="sub.id"
                  class="subcliente-checkbox"
                >
                  <input
                    type="checkbox"
                    :value="sub.id"
                    v-model="selectedSubclienteIds"
                    :disabled="form_data.status == 'desativado'"
                  />
                  <span>{{ sub.nome }}</span>
                </label>
                <div
                  v-if="grupo.subclientes.length === 0"
                  class="text-xs"
                  style="color: var(--icon); padding: 2px 4px;"
                >
                  Sem sub-clientes
                </div>
              </div>
            </div>
          </div>

          <div class="data_set">
            <div style="min-width: 142px">Perfil:</div>
            <div style="color: var(--icon)">
              {{ set_data.perfil.nome }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0008')
                "
                :style="iconStyle()"
                @click="selectTable('perfil')"
              >
                <Icon icon="lucide:shield" />
              </button>
            </div>
          </div>

          <div class="data_set" v-if="!isClientType">
            <div style="min-width: 142px">Horário:</div>
            <div style="color: var(--icon)">
              {{ set_data.horario }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0017')
                "
                :style="iconStyle()"
                @click="selectTable('horario')"
              >
                <Icon icon="lucide:calendar" />
              </button>
            </div>
          </div>

          <!-- Responsável -->
          <div class="data_set" v-if="!isClientType">
            <div style="min-width: 142px">Responsável:</div>
            <div style="color: var(--icon)">
              {{ set_data.responsavel.user }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0013')
                "
                :style="iconStyle()"
                @click="openDialog('responsavel')"
              >
                <Icon icon="lucide:user-cog" />
              </button>
            </div>
          </div>

          <div class="data_set" v-if="!isClientType">
            <div style="min-width: 142px">Chefe:</div>
            <div style="color: var(--icon)">
              {{ set_data.chefe.user }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0015')
                "
                :style="iconStyle()"
                @click="openDialog('chefe')"
              >
                <Icon icon="lucide:user-cog" />
              </button>
            </div>
          </div>

          <div class="data_set flex justify-between" v-if="!isClientType">
            <div style="min-width: 142px">Armazem:</div>
            <div style="color: var(--icon)">
              {{ set_data.armazem.nome }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0009')
                "
                :style="iconStyle()"
                @click="openDialog('armazem')"
              >
                <Icon icon="lucide:home" />
              </button>
            </div>
          </div>

          <!-- Sucursal so se aplica a tecnico/geral/administrador -->
          <div class="data_set flex justify-between" v-if="!isClientType">
            <div style="min-width: 142px">Sucursal:</div>
            <div style="color: var(--icon)">
              {{ set_data.sucursal?.sucursal || "N/A" }}
            </div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0009')
                "
                :style="iconStyle()"
                @click="openDialog('sucursal')"
              >
                <Icon icon="lucide:building" />
              </button>
            </div>
          </div>

          <div
            class="data_set flex justify-between"
            v-if="!isClientType && !create_user"
          >
            <div style="min-width: 142px">Valencias:</div>
            <div style="color: var(--icon)"></div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0018')
                "
                :style="iconStyle()"
                @click="selectTable('valencias')"
              >
                <Icon icon="lucide:wrench" />
              </button>
            </div>
          </div>

          <div
            class="data_set flex justify-between"
            v-if="!isClientType && !create_user"
          >
            <div style="min-width: 142px">Documentos:</div>
            <div style="color: var(--icon)"></div>
            <div class="pl-5 flex items-center h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0021')
                "
                :style="iconStyle()"
                @click="selectTable('documentoUtilizador')"
              >
                <Icon icon="lucide:file" />
              </button>
            </div>
          </div>
        </div>

        <div class="data_set_class mb-2" v-if="!isClientType && isTecnicoType">
          <div class="data_set gap-y-1" v-if="!isClientType">
            <div style="min-width: 142px">Viatura:</div>
            <div style="color: var(--icon)">
              {{ set_data.viatura.matricula ?? "N/A" }}
            </div>
            <div class="ml-5 flex items-center justify-end gap-2 h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0029')
                "
                v-if="Object.keys(set_data.viatura).length != 0"
                @click="removeSelectResult('viatura')"
              >
                <Icon class="remove-icon" icon="mingcute:delete-back-fill" />
              </button>
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0029')
                "
                :style="iconStyle()"
                @click="openDialog('viatura')"
              >
                <Icon
                  :disabled="!validPermission('U0029')"
                  icon="lucide:truck"
                />
              </button>
            </div>
          </div>

          <div class="data_set" v-if="!isClientType">
            <div style="min-width: 142px">Tpa:</div>
            <div style="color: var(--icon)">
              {{ set_data.tpa.serie }}
            </div>
            <div class="ml-5 flex items-center justify-end gap-2 h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0011')
                "
                v-if="Object.keys(set_data.tpa).length != 0"
                @click="removeSelectResult('tpa')"
              >
                <Icon class="remove-icon" icon="mingcute:delete-back-fill" />
              </button>
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0011')
                "
                :style="iconStyle()"
                @click="openDialog('tpa')"
              >
                <Icon
                  :disabled="!validPermission('U0011')"
                  icon="lucide:credit-card"
                />
              </button>
            </div>
          </div>

          <div class="data_set" v-if="!isClientType">
            <div style="min-width: 142px">Computador:</div>
            <div style="color: var(--icon)">
              {{ set_data.computador.nome }}
            </div>
            <div class="ml-5 flex items-center justify-end gap-2 h-full">
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0012')
                "
                v-if="Object.keys(set_data.computador).length != 0"
                @click="removeSelectResult('computador')"
              >
                <Icon class="remove-icon" icon="mingcute:delete-back-fill" />
              </button>
              <button
                :disabled="
                  form_data.status == 'desativado' || !validPermission('U0012')
                "
                :style="iconStyle()"
                @click="openDialog('computador')"
              >
                <Icon
                  :disabled="!validPermission('U0012')"
                  icon="lucide:monitor"
                />
              </button>
            </div>
          </div>

          <div class="input_container" v-if="!isClientType">
            <label for="utilizador" class="input_label">Objetivo:</label>
            <input
              :disabled="
                form_data.status == 'desativado' || !validPermission('U0027')
              "
              type="number"
              min="0"
              v-model="formData.objetivoDiario"
              placeholder="Objetivo Diário"
              class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px] text-black"
            />
          </div>

          <div class="input_container">
            <label for="utilizador" class="input_label">RAE:</label>
            <input
              :disabled="form_data.status == 'desativado'"
              type="text"
              v-model="formData.certificado"
              placeholder="RAE"
              class="w-full text-[20px] border-1 border-[#ccc] p-1 rounded-[5px] text-black"
            />
          </div>
        </div>
      </div>

      <div id="right_form" class="right_form">
        <div class="grid grid-cols-[auto_1fr]">
          <div class="img_btn_container" :style="{ flex: '0 0 auto' }">
            <div class="img_container">
              <img id="user_img" :src="formData.foto" alt="user image" />
            </div>

            <div style="margin-top: 0.5rem">
              <label for="input-file">
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  :style="{
                    color:
                      form_data.status == 'desativado'
                        ? 'var(--desativado)'
                        : 'var(--icon)',
                    cursor:
                      form_data.status == 'desativado'
                        ? 'not-allowed'
                        : 'pointer',
                  }"
                ></i>
              </label>
              <input
                style="color: var(--text)"
                :disabled="form_data.status == 'desativado'"
                type="file"
                accept="image/jpeg, image/png, image/jpg"
                id="input-file"
                @change="upload_img"
                hidden
              />
            </div>
          </div>
          <div class="signature_container" :style="{ flex: '0 0 auto' }">
            <div class="signature_div">
              <div class="signature_field_container">
                <img
                  id="signature_img"
                  :src="formData.assinatura"
                  alt="asinatura"
                  style="max-width: 200px"
                />
              </div>
              <div class="signature_icon_container"></div>
            </div>
          </div>
        </div>

        <div class="contato_container p-2">
          <!-- <h3>Contato:</h3> -->
          <div style="display: flex; gap: 1rem">
            <div style="display: flex">
              <label style="min-width: 5rem">Nome:</label>
              <input
                :disabled="form_data.status == 'desativado' || !create_user"
                id="contacto_nome_field"
                type="text"
                v-model="formData.contacto_nome"
                placeholder="Nome"
                :class="{
                  'bg-gray-500 text-[var(--text)]': !create_user,
                  'input-required': create_user && isEmptyField('contacto_nome'),
                }"
              />
            </div>
            <div style="display: flex">
              <label style="min-width: 5rem">Email:</label>
              <input
                :disabled="form_data.status == 'desativado'"
                id="email_field"
                type="text"
                v-model="formData.email"
                placeholder="Email"
                :class="{ 'input-required': isEmptyField('email') }"
              />
            </div>
          </div>
          <div style="display: flex; gap: 1rem">
            <div style="display: flex">
              <label style="min-width: 5rem">Telefone:</label>
              <input
                :disabled="form_data.status == 'desativado'"
                id="telefone_field"
                type="text"
                v-model="formData.telefone"
                placeholder="Telefone"
                :class="{ 'input-required': isEmptyField('telefone') }"
              />
            </div>
            <div style="display: flex">
              <label style="min-width: 5rem">Telemovel:</label>
              <input
                :disabled="form_data.status == 'desativado'"
                id="telemovel_field"
                type="text"
                v-model="formData.telemovel"
                placeholder="Telemovel"
                :class="{ 'input-required': isEmptyField('telemovel') }"
              />
            </div>
          </div>
          <div style="display: flex">
            <label style="min-width: 5rem">Descriçao:</label>
            <textarea
              :disabled="form_data.status == 'desativado'"
              v-model="formData.descricao"
              placeholder="Descrição"
              class="input_field textarea"
              style="resize: none"
            ></textarea>
          </div>
          <div
            class="data_set_class flex flex-col"
            v-if="isTecnicoType && !create_user"
          >
            <div
              class="grid grid-cols-[auto_min-content_min-content] gap-x-2 mr-4"
            >
              <div>
                <label>Férias</label>
              </div>
              <div class="w-[4px]">
                <button
                  :disabled="
                    form_data.status == 'desativado' ||
                    !validPermission('U0019')
                  "
                  :style="iconStyle()"
                  @click="selectTable('ferias')"
                >
                  <Icon icon="lucide:calendar" />
                </button>
              </div>
              <div></div>
              <div>
                <label>Assiduidade</label>
              </div>
              <div class="w-[4px]">
                <button
                  :disabled="
                    form_data.status == 'desativado' ||
                    !validPermission('U0020')
                  "
                  :style="iconStyle()"
                  @click="selectTable('assiduidade')"
                >
                  <Icon icon="lucide:calendar" />
                </button>
              </div>
              <div></div>
              <div>
                <label>Transferir OS:</label>
              </div>
              <div class="w-[4px]">
                <button
                  :disabled="
                    form_data.status == 'desativado' ||
                    !validPermission('U0024')
                  "
                  :style="iconStyle()"
                  @click="selectTable('transferirordemServico')"
                >
                  <Icon icon="lucide:truck" />
                </button>
              </div>
              <div></div>
              <div>
                <label>Transferir Artigo:</label>
              </div>
              <div class="w-[4px]">
                <button
                  :disabled="
                    form_data.status == 'desativado' ||
                    !validPermission('U0025')
                  "
                  :style="iconStyle()"
                  @click="selectTable('transferirArtigoViatura')"
                >
                  <Icon icon="lucide:truck" />
                </button>
              </div>
              <div></div>
              <div>
                <label>Ordem De Serviço:</label>
              </div>
              <div class="w-[4px]">
                <button
                  :disabled="
                    form_data.status == 'desativado' ||
                    !validPermission('U0026')
                  "
                  :style="iconStyle()"
                  @click="selectTable('ordemServico')"
                >
                  <Icon icon="lucide:clipboard" />
                </button>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Botoes Criar , Atualizar, Desativar, Ativar -->
    <div style="display: flex; gap: 0.5rem">
      <button
        v-if="create_user && this.validPermission('U0003')"
        class="btn"
        @click="showConfirm($event, 'create')"
        :font_size="14"
      >
        Criar
      </button>
      <button
        v-if="
          !create_user &&
          this.validPermission('U0022') &&
          form_data.status === 'ativo'
        "
        class="btn"
        :style="{ backgroundColor: 'rgb(0, 102, 152)' }"
        @click="showConfirm($event, 'update')"
        :font_size="14"
      >
        Atualizar
      </button>
      <button
        v-if="
          !create_user &&
          this.validPermission('U0023') &&
          form_data.status === 'ativo'
        "
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'red' }"
        @click="showConfirm($event, 'disable')"
      >
        Desativar
      </button>
      <button
        v-if="
          !create_user &&
          this.validPermission('U0023') &&
          form_data.status === 'desativado'
        "
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }"
        @click="showConfirm($event, 'disable')"
      >
        Ativar
      </button>
      <ConfirmPopUp ref="myConfirm" @accept="onAccept" :message="askMessage" />
    </div>
  </div>
  <Dialog
    v-if="dialogStatus"
    :pagination="with_pagination"
    @close="dialogStatus = false"
    @returnData="setSelectResult"
    :propsData="dialogProps"
  />

  <Signature
    v-if="showSignature"
    :initial-signature="formData.assinatura"
    @close="showSignature = false"
    @save="onSaveSignature"
  />
</template>

<script>
import AppButton from "@/components/updated/button.vue";

import axios from "axios";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import Signature from "@/components/signature/signature.vue";

export default {
  mixins: [permissionMixin],
  name: "AppUserForm",
  components: {
    AppButton,
    ConfirmPopUp,
    Dialog,
    Signature,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_user: {
      type: Boolean,
      default: () => false,
    },
    update_visibility: {
      type: Boolean,
      default: () => false,
    },
    disable_visibility: {
      type: Boolean,
      default: () => false,
    },
  },

  created() {
    // Guardas contra respostas fora de ordem dos pedidos de sub-clientes.
    this._subclientesRequestId = 0;
    this._userSubclientesRequestId = 0;
  },

  data() {
    return {
      formData: {},
      baseURl: process.env.VUE_APP_URL_BASE,
      emit_type: "",
      dialogStatus: false,
      currentType: null,
      with_pagination: false,

      showSignature: false,

      availableSubclientes: [],
      userSubclientes: [],
      selectedSubclienteIds: [],
      originalSubclienteIds: null,
      loadingSubclientes: false,

      dialogProps: {
        multi: false,
        entity: ["armazem"],
        sideBar: true,
        queryParams: {
          armazem: "custom=1",
          sucursal: "custom=1",
          viatura: "custom=1",
          tpa: "custom=1",
          tputilizador: "custom=1",
        },
        askMessage: "Deseja copiar as permissões deste tipo de utilizador",
        specialQuery: {
          chefe: "utilizador/s/chefe/",
          responsavel: "utilizador/s/responsavel/",
        },
      },
    };
  },

  computed: {
    isClientType() {
      return this.set_data?.tipo_utilizador?.nome === "cliente";
    },
    isTecnicoType() {
      return this.set_data?.tipo_utilizador?.nome === "tecnico";
    },

    currentClienteId() {
      return Number(this.set_data?.cliente?.id || 0);
    },

    // Contexto que determina que sub-clientes precisam de ser carregados.
    subclientesContext() {
      return {
        show: !!this.show,
        isCliente: this.isClientType,
        utilizadorId: Number(this.form_data?.id || 0),
        clienteId: this.currentClienteId,
      };
    },

    showSubclientesPanel() {
      return (
        this.isClientType &&
        (this.currentClienteId > 0 || this.userSubclientes.length > 0)
      );
    },

    // Sub-clientes do cliente selecionado + todos os acessos que o utilizador
    // já tem noutros clientes, agrupados por cliente.
    subclienteGroups() {
      const grupos = new Map();
      const currentId = this.currentClienteId;
      const vistos = new Set();

      const addGrupo = (clienteId, clienteNome) => {
        if (!grupos.has(clienteId)) {
          grupos.set(clienteId, {
            clienteId,
            clienteNome: clienteNome || "Sem cliente",
            isCurrent: clienteId === currentId,
            subclientes: [],
          });
        }
        return grupos.get(clienteId);
      };

      const addSubcliente = (clienteId, clienteNome, sub) => {
        if (vistos.has(sub.id)) return;
        vistos.add(sub.id);
        addGrupo(clienteId, clienteNome).subclientes.push(sub);
      };

      if (currentId > 0) {
        const nomeCliente = this.set_data?.cliente?.cliente;
        addGrupo(currentId, nomeCliente);
        this.availableSubclientes.forEach((sub) =>
          addSubcliente(currentId, nomeCliente, { id: sub.id, nome: sub.nome })
        );
      }

      this.userSubclientes.forEach((sub) => {
        const clienteId = Number(sub.cliente_id || 0);
        // Só abre grupo à parte quando o cliente é mesmo outro; sem cliente
        // conhecido fica no cliente atual, para não duplicar a listagem.
        const outroCliente = clienteId > 0 && clienteId !== currentId;
        addSubcliente(
          outroCliente ? clienteId : currentId,
          outroCliente ? sub.cliente_nome : this.set_data?.cliente?.cliente,
          { id: sub.id, nome: sub.nome }
        );
      });

      return [...grupos.values()]
        .sort(
          (a, b) =>
            (b.isCurrent ? 1 : 0) - (a.isCurrent ? 1 : 0) ||
            String(a.clienteNome).localeCompare(String(b.clienteNome))
        )
        .map((grupo) => ({
          ...grupo,
          subclientes: [...grupo.subclientes].sort((a, b) =>
            String(a.nome || "").localeCompare(String(b.nome || ""))
          ),
        }));
    },

    // Só há agrupamento visível quando os acessos estão em clientes distintos.
    hasMultiplosClientes() {
      return this.subclienteGroups.length > 1;
    },

    // subcliente_id -> cliente_id, para saber onde cai cada seleção.
    subclienteClienteMap() {
      const mapa = {};
      this.subclienteGroups.forEach((grupo) =>
        grupo.subclientes.forEach((sub) => {
          mapa[sub.id] = grupo.clienteId;
        })
      );
      return mapa;
    },

    outrosClientesCount() {
      return this.selectedSubclienteIds.filter(
        (id) => this.subclienteClienteMap[id] !== this.currentClienteId
      ).length;
    },
  },

  methods: {
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },

    iconStyleObr() {
      if (this.form_data.status === "desativado") {
        return {
          color: "var(--desativado)",
          cursor: "not-allowed",
        };
      } else if (this.set_data.tipo_utilizador.id == 0) {
        return {
          color: "var(--obrigatorio)",
          cursor: "pointer",
        };
      }
      return {
        color: "var(--icon)",
        cursor: "pointer",
      };
    },

    iconStyle() {
      return {
        color:
          this.form_data.status === "desativado"
            ? "var(--desativado)"
            : "var(--icon)",
        cursor:
          this.form_data.status === "desativado" ? "not-allowed" : "pointer",
      };
    },

    setSelectResult(result) {
      console.log("RESPOSTA:", result);

      if (this.currentType == "tputilizador") {
        this.set_data.tipo_utilizador = result[[this.currentType]];
        this.$emit("setTipoUtilizador", result[[this.currentType]]);
        // this.showConfirm(event, "perfil set");
        return;
      }
      if (this.currentType == "cliente") {
        console.log("cliente", result.cliente.cliente);
        this.set_data.cliente = {
          id: result.cliente.cliente.id,
          cliente: result.cliente.cliente.nome,
        };
        return;
      }
      if (this.currentType == "tpa") {
        console.log("tpa", result.tpasemutilizador);
        this.set_data.tpa = {
          id: result.tpasemutilizador.id,
          serie: result.tpasemutilizador.serie,
        };
        return;
      }
      if (this.currentType == "computador") {
        console.log("pc", result.computadorsemutilizador);
        this.set_data.computador = {
          id: result.computadorsemutilizador.id,
          codigo: result.computadorsemutilizador.codigo,
        };
        return;
      }

      this.set_data[this.currentType] = result[[this.currentType]];
    },

    removeSelectResult(item) {
      if (item == "viatura") {
        this.set_data.viatura = { id: 0, matricula: "N/A" };
      } else if (item == "tpa") {
        this.set_data.tpa = { id: 0, serie: "N/A" };
      } else if (item == "computador") {
        this.set_data.computador = { id: 0, codigo: "N/A" };
      }
    },

    openDialog(entity) {
      if (entity == "cliente" || entity == "tpa" || entity == "computador") {
        this.with_pagination = true;
      } else this.with_pagination = false;

      if (entity == "tpa") {
        this.dialogProps.entity[0] = "tpasemutilizador";
        this.currentType = entity;
        this.dialogStatus = true;
      } else if (entity == "computador") {
        this.dialogProps.entity[0] = "computadorsemutilizador";
        this.currentType = entity;
        this.dialogStatus = true;
      } else {
        this.dialogProps.entity[0] = entity;
        this.currentType = entity;
        this.dialogStatus = true;
      }
    },

    onAccept() {
      if (this.emit_type == "create") {
        this.createUser();
      } else if (this.emit_type == "update") {
        this.updateUser();
      } else if (this.emit_type == "disable") {
        this.disableUser();
      } else if (this.emit_type == "perfil set") {
        this.$emit("setTipoUtilizador", this.set_data.tipo_utilizador);
      } else {
        this.$emit("show_table", this.emit_type);
      }

      console.log("Confirmed!");
    },

    selectTable(name) {
      // Logic to handle selecting armazem
      console.log("select:", name);

      this.$emit("show_table", name);
    },

    async upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("user_img");
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append("foto", file);
        this.formData.newFoto = formData;
      }
    },

    async upload_signature(event) {
      console.log("inside upload method");
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("signature_img");
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append("foto", file);
        this.formData.newAssinatura = formData;
      }
    },

    onSaveSignature(signatureBase64) {
      // 1) Fechamos o modal
      this.showSignature = false;

      const img = document.getElementById("signature_img");
      img.src = signatureBase64;

      // 3) Se precisar enviar ao servidor, converta a base64 em Blob antes
      //    Exemplo de conversão:
      const blob = this.dataURLToBlob(signatureBase64);
      const formData = new FormData();
      formData.append("foto", blob, "signature.png");

      this.formData.assinatura = signatureBase64;
      this.formData.newAssinatura = formData;
    },

    // Função utilitária para converter dataURL em blob
    dataURLToBlob(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    resetSubclientesState() {
      this.availableSubclientes = [];
      this.userSubclientes = [];
      this.selectedSubclienteIds = [];
      this.originalSubclienteIds = null;
    },

    // Marca/desmarca todos os sub-clientes listados de um cliente.
    setGrupoSelecao(grupo, selecionar) {
      if (this.form_data.status === "desativado") return;
      const ids = grupo.subclientes.map((sub) => sub.id);
      if (selecionar) {
        const atuais = new Set(this.selectedSubclienteIds);
        ids.forEach((id) => atuais.add(id));
        this.selectedSubclienteIds = [...atuais];
      } else {
        this.selectedSubclienteIds = this.selectedSubclienteIds.filter(
          (id) => !ids.includes(id)
        );
      }
    },

    async fetchSubclientes(clienteId) {
      if (!clienteId || clienteId === 0) {
        this.availableSubclientes = [];
        return;
      }
      const requestId = ++this._subclientesRequestId;
      this.loadingSubclientes = true;
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/localinstalacao/cliente/${clienteId}/subclientes/`
        );
        if (requestId !== this._subclientesRequestId) return;
        this.availableSubclientes = res.data?.data || [];
      } catch (e) {
        console.error("Error fetching subclientes:", e);
        if (requestId === this._subclientesRequestId)
          this.availableSubclientes = [];
      } finally {
        if (requestId === this._subclientesRequestId)
          this.loadingSubclientes = false;
      }
    },

    // Carrega todos os sub-clientes a que o utilizador tem acesso,
    // independentemente do cliente a que pertencem.
    async loadExistingSubclientes(utilizadorId) {
      if (!utilizadorId || utilizadorId === 0) return;
      const requestId = ++this._userSubclientesRequestId;
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/utilizador/${utilizadorId}/subclientes/`
        );
        if (requestId !== this._userSubclientesRequestId) return;
        const subs = res.data?.data || [];
        this.userSubclientes = subs;
        this.selectedSubclienteIds = subs.map((s) => s.id);
        this.originalSubclienteIds = subs.map((s) => s.id);
      } catch (e) {
        console.error("Error loading existing subclientes:", e);
      }
    },

    createUser() {
      if (!this.isValidForm()) return;

      const formData = this.getFormData();
      console.log("create formdata:", formData);
      this.$emit("createUser", formData);
    },

    updateUser() {
      const formData = this.getFormData();

      if (!this.formData.password || this.formData.password === "") {
        delete formData.password;
      }

      this.$emit("updateUser", formData);
    },

    disableUser() {
      const formData = this.getFormData();
      this.$emit("disableUser", formData);
    },

    isValidForm() {
      let missingFields = [];

      if (!this.formData.utilizador) missingFields.push("Utilizador");
      if (!this.formData.cc && !this.isClientType) missingFields.push("CC");

      if (this.create_user && !this.formData.password)
        missingFields.push("Senha");
      if (!this.formData.contacto_nome) missingFields.push("Nome do Contato");
      if (!this.formData.email) missingFields.push("Email");
      if (!this.formData.telefone) missingFields.push("Telefone");
      if (!this.formData.telemovel) missingFields.push("Telemóvel");
      if (this.set_data.tipo_utilizador.id === 0)
        missingFields.push("Tipo de Utilizador");

      if (
        this.set_data.tipo_utilizador.nome == "cliente" &&
        this.set_data.cliente.id == 0
      ) {
        missingFields.push("Cliente");
      }

      if (missingFields.length > 0) {
        toast(`Preencha os campos obrigatórios: ${missingFields.join(", ")}`, {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 2000,
        });
        return false;
      }

      return true;
    },

    getFormData() {
      // originalSubclienteIds === null => acessos ainda não carregados,
      // não há nada a sincronizar (evita apagar acessos por engano).
      const subclientesChanged =
        this.originalSubclienteIds !== null &&
        JSON.stringify([...this.selectedSubclienteIds].sort((a, b) => a - b)) !==
          JSON.stringify([...this.originalSubclienteIds].sort((a, b) => a - b));

      const formDataObject = {
        ...this.formData,
        ...this.set_data,
        selectedSubclienteIds: this.selectedSubclienteIds,
        subclientesChanged,
      };

      // Se não estiver criando um novo utilizador e a senha estiver vazia, remova o campo de senha
      if (
        !this.create_user &&
        (!this.formData.password || this.formData.password === "")
      ) {
        delete formDataObject.password;
      }
 

      return formDataObject;
    },
    close() {
      this.$emit("close");
    },
    updateFormData() {
      this.formData = { ...this.form_data };
    },

    isEmptyField(field) {
      if (
        [
          "utilizador",
          "contacto_nome",
          "email",
          "telefone",
          "telemovel",
          "nif",
          "cc",
        ].includes(field)
      ) {
        return (
          // return this.formData[field] === "" || this.formData[field] === undefined;

          this.formData[field] === "" || Array.isArray(this.formData[field])
        );
      }

      if (field === "password" && this.create_user) {
        // return !this.formData.password;
        return this.formData.password === "";
      }

      return false;
    },
  },

  watch: {
    form_data: {
      handler() {
        this.updateFormData();
        //this.isEmptyContactField()
      },
      immediate: true,
      deep: true,
    },
    subclientesContext: {
      handler(ctx, anterior) {
        if (!ctx.show || !ctx.isCliente) {
          this.availableSubclientes = [];
          this.userSubclientes = [];
          this.selectedSubclienteIds = [];
          // Se os acessos já tinham sido carregados, manter o original para
          // que deixar de ser do tipo cliente os remova ao gravar.
          if (this.originalSubclienteIds === null) this.originalSubclienteIds = [];
          return;
        }

        const mudouUtilizador =
          !anterior ||
          !anterior.show ||
          !anterior.isCliente ||
          anterior.utilizadorId !== ctx.utilizadorId;

        if (mudouUtilizador) {
          this.resetSubclientesState();
          if (ctx.utilizadorId > 0) {
            this.loadExistingSubclientes(ctx.utilizadorId);
          } else {
            this.originalSubclienteIds = [];
          }
        }

        // Só a lista disponível depende do cliente escolhido; os acessos já
        // atribuídos noutros clientes mantêm-se visíveis e selecionados.
        if (mudouUtilizador || anterior.clienteId !== ctx.clienteId) {
          this.fetchSubclientes(ctx.clienteId);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* @import "../node_modules/@popperjs/core/styles/style.css"; */

.edit-icon {
  font-size: 1.5em;
  color: var(--icon);
  cursor: pointer;
}

.remove-icon {
  font-size: 1.5em;
  filter: drop-shadow(0 0 2px var(--obrigatorio));
  color: var(--obrigatorio);
  cursor: pointer;
}

.form_btn_container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--fundoForm);
  padding: 1px;
}

.form_container {
  display: flex;
  gap: 2px;
  padding: 1px;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  /* gap: 0.2rem; */
  gap: 1rem;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: var(--label);
}

label {
  display: block;
  color: var(--label);
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
input[type="password"],
input[type="number"],
select {
  /* width: 20px; */
  padding: 0.3rem;
  /* Reduce padding */
  font-size: 14px;
  width: 100%;

  border-radius: 5px;
  border: 1px solid #cccccc;
}

.input_field.textarea {
  /* Define width and height as needed */
  width: 200px;
  height: 60px;
  color: var(--text);
  /* Add other styles as needed */
}

.btn_div {
  color: var(--label);
  display: flex;
  padding-left: 1rem;
  align-items: center;
  gap: 0.6rem;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.data_set {
  font-size: 14px;
  color: var(--label);
  display: flex;
  min-width: 23em;
  justify-content: space-between;
  /* gap: 0.3rem;*/
}

.data_set_subclientes {
  font-size: 14px;
  color: var(--label);
  padding: 0.5rem;
  border-radius: 8px;
  background-color: rgba(255,255,255,0.04);
}

.subclientes_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.subclientes_resumo {
  font-size: 12px;
  color: var(--icon);
  white-space: nowrap;
}

.subclientes_aviso {
  color: var(--obrigatorio);
}

.subclientes-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 4px 0;
}

.subcliente_grupo {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px;
  border-radius: 6px;
  border-left: 3px solid var(--icon);
  background-color: rgba(255, 255, 255, 0.03);
}

.subcliente_grupo_simples {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.subcliente_grupo_outro {
  border-left-color: var(--obrigatorio);
}

.subcliente_grupo_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: var(--label);
  padding: 0 4px 2px 4px;
}

.subcliente_grupo_nome {
  font-weight: 600;
}

.subcliente_grupo_acoes {
  display: flex;
  gap: 6px;
}

.subcliente_grupo_acoes button {
  font-size: 11px;
  color: var(--icon);
  text-decoration: underline;
  cursor: pointer;
}

.subcliente-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--icon);
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
}

.subcliente-checkbox:hover {
  background-color: rgba(255,255,255,0.06);
}

.subcliente-checkbox input[type="checkbox"] {
  accent-color: var(--icon);
  cursor: pointer;
}

.right_form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  align-items: center;
  /* display: none; */
}

.img_signature_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
}

.img_container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--fundoForm, #1e293b);
  border: 3px solid var(--label, #3b82f6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.signature_container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.tpa_certificado_container {
  display: flex;
  flex-direction: column;
}

.signature_div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.signature_field_container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  min-height: 100px;
  background-color: var(--fundoForm, #1e293b);
  border: 2px solid var(--label, #3b82f6);
  border-radius: 0.5rem;
  padding: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.signature_field_container img {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 0.25rem;
}

.signature_icon_container {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  padding-top: 1rem;
}

.contato_container {
  padding: 0.3rem;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 0.5rem;
}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  width: 100%;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 30%;
  /* Adjust label width as needed */
  color: var(--label);
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--fundoApp);
  background-color: var(--label);
}

.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}

.ser_data {
  display: flex;
  align-items: center; /* Alinha o texto verticalmente ao centro */
  justify-content: space-between; /* Espaça os rótulos e valores */
  gap: 0.5rem; /* Espaçamento entre os itens */
}

.ser_data label {
  min-width: 120px; /* Define uma largura mínima fixa para os rótulos */
  text-align: left; /* Alinha os rótulos à esquerda */
  font-weight: bold; /* Destaca os rótulos */
  color: var(--label); /* Cor branca para os rótulos */
}

.ser_data div {
  flex-grow: 1; /* Faz o valor ocupar o espaço restante */
  color: var(--icon); /* Define a cor padrão do texto */
  text-align: left; /* Alinha o texto à esquerda */
  word-break: break-word; /* Permite quebra de linha no texto */
}

.ser_data button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
}

.ser_data button:disabled {
  cursor: not-allowed;
  color: var(--desativado);
}
</style>
